import axios from "@/axios";
import {Module} from "vuex";

const state = () => ({
    countries: {}
});

const getters = {
    getCountries(state: any){
        return state.countries;
    }
};
const actions = {
    async fetchCountries({commit}: any){
        const response = await axios.get('/country');
        commit('saveCountries', response.data);
    }
};
const mutations = {
    saveCountries(state: any, payload: any){
        state.countries = payload;
        localStorage.setItem('countries',JSON.stringify(state.countries))
    }
};

export const countries: Module<any, any> = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}